/** Écran d'accueil (index.html:1870-1876). */
import { DIFFS, NB_DEFIS } from '@ordre-cache/shared';
import { GAMES, state } from '../../state';
import { progOf } from '../../storage';
import { totalScore, totalStars } from '../../score';
import { activeProfile } from '../../profile';

export function renderHome(): void {
  const prof = activeProfile();
  const ppAv = document.getElementById('ppAv');
  if (ppAv) ppAv.textContent = prof ? prof.avatar : '👤';
  const ppName = document.getElementById('ppName');
  if (ppName) ppName.textContent = prof ? prof.name : 'Invité';

  let tot = 0;
  let done = 0;
  GAMES.forEach((g) => {
    const pr = progOf(g.id, state.diff);
    tot += NB_DEFIS;
    done += pr.filter(Boolean).length;
  });
  const foot = document.getElementById('homeFoot');
  if (foot) {
    foot.innerHTML = `🏆 <b style="color:var(--gold)">${totalScore()} pts</b> · <span style="color:var(--star,#ffe08a)">★ ${totalStars(state.diff)}/${tot * 3}</span> · Niveau ${DIFFS[state.diff]} : ${done}/${tot} défis réussis`;
  }
}
